export default {
    domainrequestdata: [
	{
		id: 1,
		"Customer": "Orn LLC orn@example.com",
		"Domain": "ornllc",
		"noofemployee": "10",
		"Package": "FREE TRIAL\n                                                            monthly",
		"CreatedOn": "15 Dec 2023, 04:35 PM",
		"Status": "Rejected",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	},
	{
		id: 2,
		"Customer": "Accent Technology\n     accent@example.com",
		"Domain": "accent00",
		"noofemployee": "100",
		"Package": "ENTERPRISE\n                                                            lifetime",
		"CreatedOn": "15 Dec 2023, 04:35 PM",
		"Status": "Approved",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	},
	{
		id: 3,
		"Customer": "Express Advertisingexpress@example.com",
		"Domain": "expadvertising",
		"noofemployee": "200",
		"Package": "ENTERPRISE\n                                                            lifetime",
		"CreatedOn": "04 Dec 2023, 12:38 PM",
		"Status": "Approved",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	},
	{
		id: 4,
		"Customer": "lexicon Technologieslexicon@example.com",
		"Domain": "lexicontech05",
		"noofemployee": "50",
		"Package": "Basic\n                                                            monthly",
		"CreatedOn": "28 Nov 2023, 03:25 PM",
		"Status": "Approved",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	},
	{
		id: 5,
		"Customer": "Sumo Soft Limitedsumo@example.com",
		"Domain": "sumosoftltd",
		"noofemployee": "75",
		"Package": "Basic\n                                                            Yearly",
		"CreatedOn": "20 Nov 2022, 02:47 PM",
		"Status": "Rejected",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	},
	{
		id: 6,
		"Customer": "Repair Group Corepair@example.com",
		"Domain": "repairco1993",
		"noofemployee": "10",
		"Package": "ENTERPRISE\n                                                            monthly",
		"CreatedOn": "15 Dec 2022, 04:35 PM",
		"Status": "Rejected",
		"Action": "Edit\n             \n         \n         \n            \n                 \n                 Delete"
	}
]
}